// eslint-disable-next-line func-names
export default function (amount) {
  const val = parseFloat(amount)
  if (!Number.isNaN(val)) {
    return `$${val.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
  }

  return '?'
}
